angular
	.module 'App.Module.CustomerPrefix', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'customer_prefixes',
				url: '/customer_prefixes',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@customer_prefixes':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Users.Customers'
					searchParams:
						repositoryName: 'CustomerPrefixRepository'
						title: 'general.customer.prefixes'

			.state 'customer_prefixes.edit',
				url: '/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					customerPrefix: (CustomerPrefixRepository, $stateParams) ->
						return CustomerPrefixRepository.getEntity $stateParams.id

			.state 'customer_prefixes.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'CustomerPrefixController'
						controllerAs: 'vm'
						templateUrl: '@app/customer-prefix/customer-prefix.view.html'
